/* eslint-disable */
import api from '@/utils/api.js'

/* 
用户注册
/user2/RegisterUser       post(formData)
  *payload             json数据，User对象(手机号必填)
  *mobileVerifyCode    手机验证码（通过auth2.SendVerifyCode获得）
  authToken            之前通过login得到的认证TOKEN（可以为空）

  ----payload
  UserID2  str    用户名(英文数字下划线)
  Name     str    昵称
  Mobile   str    手机号
  Email    string `orm:"size(32)" json:"email"`
  IDCardNo string `orm:"size(18);column(id_card_no)" json:"idCardNo"` // 身份证号
*/
export const APIRegisterUser = async (string, noLoading = true) => {
  try {
    let res = await api('v2/user2/RegisterUser', {
      method: 'POST',
      data: string,
      noLoading
    })
    return res
  } catch (e) {
    console.error('RegisterUser', e)
    throw e
  }
}

/* 
发送验证码
/auth2/SendVerifyCode         post
  captchaID         str         图片验证码ID
  captchaValue      str         图片验证码值
  authToken          str         之前的认证token
  *authID            str         手机号或邮件
*/
export const APISendVerifyCode = async (string, noLoading = true) => {
  try {
    let res = api('v2/auth2/SendVerifyCode', {
      method: 'POST',
      data: string,
      noLoading
    })
    return res
  } catch (e) {
    console.error('/auth2/SendVerifyCode', e)
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/apis/APIAuth.js